import React, { useRef } from 'react'
import Dropdown from '../../dropdown/Dropdown'
import CATEGORYS from './categorys.json'

const CategoryFilter = ({ filterValue, updateFilter, date, updateDate }) => {
  const containerButtons = useRef()

  const scrollLeft = () => {
    containerButtons.current.scrollLeft = containerButtons.current.scrollLeft - 100
  }
  const scrollRight = () => {
    containerButtons.current.scrollLeft = containerButtons.current.scrollLeft + 100
  }

  return (
    <div className="header-prog">
      <div className="category-all-button">
        <button type="button" onClick={() => updateFilter(null)} className={`nav-link ${!filterValue && 'active'}`}>Todos</button>
      </div>
      <div className="category-button" onClick={scrollLeft}>
        <svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.55469 13.5L1.55469 7.5L7.55469 1.5" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>

      {/* Ocultos en modo tablet & mobile */}
      <Dropdown value={date} setValue={updateDate} options={['Hoy', 'Mañana']} addClass={'tablet-only'} addStyle={{ marginRight: '10px', minWidth: '200px' }} />
      <div className="tablet-only" style={{ width: '10px' }}></div>

      <div className="category-list" ref={containerButtons}>
        {/* Ocultos en modo tablet & mobile */}
        <button type="button" onClick={() => updateFilter(null)} className={`nav-link tablet-only ${!filterValue && 'active'}`}>Todos</button>
        {
          CATEGORYS.categorys.map((item, i) => {
            return (
              <button key={`category-guide-${i}`} type="button" onClick={() => updateFilter(item.id)} className={`nav-link ${filterValue === item.id && 'active'} ${i + 1 === CATEGORYS.categorys.length && 'ultimate'}`}>{item.name}</button>
            )
          })
        }
      </div>
      <div className="category-button reflected" onClick={scrollRight}>
        <svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.55469 13.5L1.55469 7.5L7.55469 1.5" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
    </div>
  )
}

export default React.memo(CategoryFilter)